import LetterInformation from './LetterInformation.jsx';

export default LetterInformation;


// WEBPACK FOOTER //
// ./src/components/modules/letter-information/index.js